import API from 'services/api';

export const post = (form, id) => async () => {
	try {
		const { data: { response } } = await API.voucher.voucher(id, form);
		return response;
	} catch (err) { return err; }
};
